import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Box, Typography, Skeleton } from "@mui/material";

import { useUserProfessionalConnections } from "../../../../User/api/queries/useUserProfessionalConnections";

const PlayerAgent = () => {
  const { t } = useTranslation("profiles", { keyPrefix: "playerAgent" });

  const { userId } = useParams();
  const {
    data: playerConnectionsData,
    isLoading: isPlayerConnectionsLoading,
    isError: isPlayerConnectionsError,
  } = useUserProfessionalConnections(userId!);

  const playerConnections = playerConnectionsData?.items;

  if (isPlayerConnectionsLoading) {
    return (
      <Box
        sx={{
          borderRadius: "8px",
          border: "1px solid #EAECF0",
          background: "#FFF",
          padding: "20px",
          display: "flex",
          flexDirection: "column",
          gap: "20px",
        }}
      >
        <Typography
          sx={{
            color: "var(--black-100, #1C1C1C)",
            fontFamily: "Montserrat",
            fontSize: "16px",
            fontStyle: "normal",
            fontWeight: 700,
            lineHeight: "24px",
          }}
        >
          {t("agentName")}
        </Typography>
        <Box sx={{ display: "flex", flexDirection: "column", gap: "8px" }}>
          <Skeleton variant="text" height={20} width="100%" />
        </Box>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        borderRadius: "8px",
        border: "1px solid #EAECF0",
        background: "#FFF",
        padding: "20px",
        display: "flex",
        flexDirection: "column",
        gap: "20px",
      }}
    >
      <Typography
        sx={{
          color: "var(--black-100, #1C1C1C)",
          fontFamily: "Montserrat",
          fontSize: "16px",
          fontStyle: "normal",
          fontWeight: 700,
          lineHeight: "24px",
        }}
      >
        {t("agentName")}
      </Typography>
      {(!playerConnections || playerConnections.length === 0) && <Typography>{t("playerHasNoAgent")}</Typography>}

      {playerConnections && playerConnections.length > 0 && <Typography>{t("playerHasNoAgent")}</Typography>}
    </Box>
  );
};

export default PlayerAgent;
